import { render, staticRenderFns } from "./initDisease.vue?vue&type=template&id=b82ac542&"
import script from "./initDisease.vue?vue&type=script&lang=js&"
export * from "./initDisease.vue?vue&type=script&lang=js&"
import style0 from "./initDisease.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports